import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  openAccordion: null,
  lastOpenAccordion: null,
}

const accordionSlice = createSlice({
  name: "accordion",
  initialState,
  reducers: {
    setOpenAccordion(state, action) {
      state.openAccordion = action.payload
    },
    setLastOpenAccordion(state, action) {
      state.lastOpenAccordion = action.payload
    },
    resetAccordion(state) {
      state.openAccordion = null
      state.lastOpenAccordion = null
    },
  },
})

export const { setOpenAccordion, setLastOpenAccordion, resetAccordion } =
  accordionSlice.actions
export default accordionSlice
